import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'orderByName'
})
export class OrderByNamePipe implements PipeTransform {
	transform(array: any[] = []): any[] {
		array.sort((a: any, b: any) => {
			if (a.name.toUpperCase() < b.name.toUpperCase()) {
				return -1;
			} else if (a.name.toUpperCase() > b.name.toUpperCase()) {
				return 1;
			}
			return 0;
		});
		return array;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/pipes/order-by/order-by-name.ts